// @flow
export const SET_TENANT_REPORT = 'set/tenant/report';
